import { Directive, ElementRef, HostListener, Input, Output,
EventEmitter } from '@angular/core';
import { DragDropDirectiveService } from './drag-drop-directive.service';
export class DropDirective{
  
  cssHighlight:string;
	
	dropEvent:EventEmitter<any> = new EventEmitter();
  
  dragenterEvent:EventEmitter<any> = new EventEmitter();
  
  dragleaveEvent:EventEmitter<any> = new EventEmitter();
  
  dropEventMouse:EventEmitter<any> = new EventEmitter();
  
  dragoverMouseEvent:EventEmitter<any> = new EventEmitter();
private highlighted:boolean = false;
private dragItem:any;
/**
 * @param {?} el
 * @param {?} dragDropDirectiveService
 */
constructor(
private el: ElementRef,
private dragDropDirectiveService: DragDropDirectiveService
  ) {}
/**
 * @return {?}
 */
onDragEnter() {
    this.dragItem = this.dragDropDirectiveService.getDragItem();
    this.dragenterEvent.emit(this.dragItem);
  	//this.highlighted = true;
    this.highlight();
  }
/**
 * @return {?}
 */
onDragLeave(){
    this.dragItem = this.dragDropDirectiveService.getDragItem();
    this.dragleaveEvent.emit(this.dragItem);
  	//this.highlighted = false;
  	this.highlight();
  }
/**
 * @param {?} event
 * @return {?}
 */
onDragOver(event:any){
  	event.preventDefault();
    this.dragoverMouseEvent.emit(event);
  }
/**
 * @param {?} event
 * @return {?}
 */
onDrop(event:any){
    // check to see if we are getting what was sent. text/plain
    let /** @type {?} */ eventData = event.dataTransfer.getData('text');
    if (eventData && event.dataTransfer.files.length == 0){
      event.preventDefault();
      // since html draggable will not transer an object, we need to parse are string
      let /** @type {?} */ transferredObjectString = JSON.parse(eventData);
      let /** @type {?} */ transferredObjectID = transferredObjectString.id;
      let /** @type {?} */ transferredObject = transferredObjectString.object;
      this.dropEvent.emit(transferredObject);
      this.dragDropDirectiveService.setDropItem(transferredObjectID);
      
    }
    this.dropEventMouse.emit(event);
    this.highlight();
  }
/**
 * @return {?}
 */
private highlight(){
    if (this.cssHighlight){
      if (!this.highlighted){
        this.el.nativeElement.classList.add(this.cssHighlight);
      } else {
        this.el.nativeElement.classList.remove(this.cssHighlight);
      }
    }
    this.highlighted = !this.highlighted;
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[dropDirective]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: DragDropDirectiveService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cssHighlight': [{ type: Input, args: ['dropHighlight', ] },],
'dropEvent': [{ type: Output },],
'dragenterEvent': [{ type: Output },],
'dragleaveEvent': [{ type: Output },],
'dropEventMouse': [{ type: Output },],
'dragoverMouseEvent': [{ type: Output },],
'onDragEnter': [{ type: HostListener, args: ['dragenter', ] },],
'onDragLeave': [{ type: HostListener, args: ['dragleave', ] },],
'onDragOver': [{ type: HostListener, args: ['dragover', ['$event'], ] },],
'onDrop': [{ type: HostListener, args: ['drop', ['$event'], ] },],
};
}

function DropDirective_tsickle_Closure_declarations() {
/** @type {?} */
DropDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDirective.ctorParameters;
/** @type {?} */
DropDirective.propDecorators;
/** @type {?} */
DropDirective.prototype.cssHighlight;
/** @type {?} */
DropDirective.prototype.dropEvent;
/** @type {?} */
DropDirective.prototype.dragenterEvent;
/** @type {?} */
DropDirective.prototype.dragleaveEvent;
/** @type {?} */
DropDirective.prototype.dropEventMouse;
/** @type {?} */
DropDirective.prototype.dragoverMouseEvent;
/** @type {?} */
DropDirective.prototype.highlighted;
/** @type {?} */
DropDirective.prototype.dragItem;
/** @type {?} */
DropDirective.prototype.el;
/** @type {?} */
DropDirective.prototype.dragDropDirectiveService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
